import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";

export default function Login({ onLogin }) {
  const [loader, setLoader] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    const body = {
      a_email: adminId,
      a_password: password,
    };
    try {
      const resp = await Calling.AdminLogin(body);
      const { status, token, message } = resp;
      if (status) {
        toast.success(message, {
          autoClose: 2000,
        });
        localStorage.setItem("admin_ads_manager", token);
        onLogin(true);
        navigate("/all/profile");
      } else {
        toast.error(message, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error("Login failed. Please try again.", {
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <Loader />}

      <div className="flex flex-col justify-center items-center min-h-screen w-full bg-gradient-to-br from-blue-50 to-gray-100">
        <div className="flex justify-center items-center w-full px-4">
          <div className="w-full max-w-md mx-auto my-8">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-100">
              {/* Header with ads manager branding */}
              <div className="bg-blue-600 px-6 py-5">
                <h2 className="text-2xl sm:text-3xl font-bold text-white text-center">
                  Ads Manager
                </h2>
               </div>

              {/* Login form */}
              <div className="px-6 sm:px-8 py-8 sm:py-10">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label
                      htmlFor="AdminId"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="AdminId"
                      value={adminId}
                      onChange={(e) => setAdminId(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm sm:text-base shadow-sm"
                      placeholder="admin@example.com"
                      required
                    />
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-1">
                      <label
                        htmlFor="password"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Password
                      </label>
                    </div>
                    <input
                      type="password"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm sm:text-base shadow-sm"
                      placeholder="••••••••"
                      required
                    />
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                      disabled={loader}
                    >
                      {loader ? "Signing in..." : "Sign in"}
                    </button>
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                <div className="flex items-center justify-center">
                  <div className="text-xs text-gray-500">
                    Admin Ads Manager © {new Date().getFullYear()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
